import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCellphoneLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17 2C18.0544 2 18.9182 2.81588 18.9945 3.85074L19 4V20C19 21.0544 18.1841 21.9182 17.1493 21.9945L17 22H7C5.94564 22 5.08183 21.1841 5.00549 20.1493L5 20V4C5 2.94564 5.81588 2.08183 6.85074 2.00549L7 2H17ZM17 4H7V20H17V4ZM12.5 16C12.7454 16 12.9496 16.1769 12.9919 16.4101L13 16.5V17.5C13 17.7454 12.8231 17.9496 12.5899 17.9919L12.5 18H11.5C11.2546 18 11.0504 17.8231 11.0081 17.5899L11 17.5V16.5C11 16.2546 11.1769 16.0504 11.4101 16.0081L11.5 16H12.5Z",
		fill: "currentColor"
	})
});
export default SvgCellphoneLine;
